import {
  HomeIcon,
  MapPinIcon,
  ChartBarIcon,
  Cog6ToothIcon,
  BeakerIcon,
} from '@heroicons/react/24/outline';
import type { ProductConfig } from '../registry';

export default {
  slug: 'precipitate',
  icon: BeakerIcon,
  accentColor: {
    bg: 'bg-cyan-500/10',
    border: 'border-cyan-500/30',
    text: 'text-cyan-400',
  },
  navigation: [
    { name: 'DASHBOARD', href: '/precipitate/dashboard', icon: HomeIcon },
    { name: 'SITES', href: '/precipitate/sites', icon: MapPinIcon },
    { name: 'ANALYSIS', href: '/precipitate/analysis', icon: ChartBarIcon },
    { name: 'SETTINGS', href: '/precipitate/settings', icon: Cog6ToothIcon },
  ],
  landingPage: '/precipitate/dashboard',
} satisfies ProductConfig;
